import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { fromEvent, Observable } from 'rxjs';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { ClientOrdersService } from 'src/app/services/apiclient/order/clientorders.service';
import { MediaObserver } from '@angular/flex-layout';
import { AlertInvalidPricePeriodComponent } from '../alert-invalid-price-period/alert-invalid-price-period.component';
import * as moment from 'moment';

import { AlertExpireDateProductDialogComponent } from '../alert-expire-date-product-dialog/alert-expire-date-product-dialog.component';
import {SalemethodService} from "../../../services/api/salemethod/salemethod.service";

@Component({
  selector: 'app-products-time-slot-selector',
  templateUrl: './products-time-slot-selector.component.html',
  styleUrls: ['./products-time-slot-selector.component.css']
})
export class ProductsTimeSlotSelectorComponent implements OnInit {

  eventHeight: Observable<any> = fromEvent(window, "resize");
  innerHeight: number = window.innerHeight;

  productsSlotForm: FormGroup |any;

  orderDate: any = {
    day: this.tools.getStor("date_order") ? moment(this.tools.getStor("date_order")) : "",
    hour: this.tools.getStor("hour_order") ? moment(this.tools.getStor("hour_order")) : ""
  };

  now: any = moment();

  days: any;
  hours: any;

  selectedDay: any;

  loader: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<ProductsTimeSlotSelectorComponent>,
    private tools: ToolsService,
    private formBuilder: FormBuilder,
    private orderApi: ClientOrdersService,
    private media: MediaObserver,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.onWindowResize();
    this.initDays();
    this.createProductsSlotForm();
    this.setDefaultDay();
  }

  setDefaultDay() {

    const currIndexDay = this.orderDate.day ? this.orderDate.day.day() : this.now.day();
    const currHour = this.orderDate.hour ? this.orderDate.hour : this.now.format("HH:mm");
    let defaultDay: any = null;
    let defaultHour: any = null;

    for (let i = 0; i < this.days.length; i++) {
      let day = this.days[i];
      let getNextDay = false;

      if (day.index === currIndexDay) {

        // Si day fermé
        if (!day.closed && !getNextDay) {

          defaultDay = day;

          for (let j = 0; j < day.hours.length; j++) {
            let hour = day.hours[j];

            if (hour.value >= currHour) {
              defaultHour = hour.value;
              break;
            }

          }


          // Si day fermé
          if (!defaultHour) { getNextDay = true; } else { break; }


          // Si fermé_____
        } else if (day.closed && !getNextDay) {

          getNextDay = true;

        }

      } else if (getNextDay && !day.closed) {

        defaultDay = day;
        defaultHour = day.hours[0].value;
        break;

      }

    }

    this.onSelectDay(defaultDay, defaultHour);
  }

  initDays() {
    const pointOfSale:any = this.tools.getStor("point_of_sale");
    const validDays:any = [];

    pointOfSale.timetables.map((day:any) => {
      const dayByIso = moment().isoWeekday(day.day);
      const validDayHours = this.parseDayTimeSlots(day);
      const dayObj = {
        index: day.day,
        name: dayByIso.format("dddd"),
        min_name: dayByIso.format("ddd"),
        hours: validDayHours,
        closed: day.timeslots.length > 0 ? false : true,
      }
      validDays.push(dayObj);
    })

    this.days = validDays;
  }

  /**
   * @description
   * @param {any} day
   * @return {array} Heures parsées
   */
  parseDayTimeSlots(day: any): any {

    // Methode de vente actuelle
    const saleMethod:any = this.tools.getStor(SalemethodService.TAG_STORAGE);

    // Initialisation d'un tableau vide à incrémenter avec les heures parsées
    const parsedDayHours:any = [];

    // Boucle sur les timeslots du jour en parametre
    day.timeslots.map((slot:any)=> {

      // Heure du début du timeslot
      let start = moment(slot.start, "HH:mm");

      // Heure de fin du timeslot
      let end = moment(slot.end, "HH:mm");

      // Si l'heure de fin est minuit alors on ajoute un jour à l'objet moment
      if (end.format("HH:mm") === "00:00") {
        end.add(1, 'day');
      }

      // Boucle tant que l'heure de début est plus petite ou égale à l'heure de fin (L'heure du début est incrémenter à chaque fin de cycle)
      while (start.isSameOrBefore(end)) {

        // Object à incrémenter dans le tableau
        const hourObj = {
          value: start.format("HH:mm"),
          // Si le jour en parametre est le meme que le jour d'aujd et que l'heure actuelle est plus petite que l'heure du début du timeslot alors cest valide.
          unavailable: (day.day === this.now.day() && start.format("HH:mm") < this.now.format("HH:mm")) ? true : false
        }

        // On push dans le tableau
        parsedDayHours.push(hourObj);

        // On ajoute l'order slot à l'heure du début
        start.add(saleMethod.order_slot, 'minutes');
      }

    })

    return parsedDayHours;
  }

  /**
   * @description Séléctionne le jour est effectue des actions en fonction
   * @param {any} day
   * @param {string} hour optionnel
   * @return {void}
   */
  onSelectDay(day: any, hour?: string): void {
    this.productsSlotForm.get("day").setValue(day.index);
    this.selectedDay = day;
    this.hours = day.hours;
    this.productsSlotForm.get("hour").setValue(hour ? hour : this.hours[0].value, { emitEvent: false });
  }

  /**
   * @description Crée le formulaire angular
   * @return {void}
   */
  createProductsSlotForm(): void {
    this.productsSlotForm = this.formBuilder.group({
      day: ['', [Validators.required]],
      hour: ['', [Validators.required]]
    });
  }

  /**
   * @description Ferme le dialog
   * @param {boolean} changeProducts
   * @return {void}
   */
  closeDial(changeProducts: boolean): void {


    // Si changement de produit il y a alors on effectue des actions avant de fermer la popup
    if (changeProducts) {

      // Jour sélectionné
      const day :any= moment().day(this.productsSlotForm.get("day").value);

      // Si le jour selectionné est déjà passé on lui ajoute une semaine.
      if (day.isBefore(this.now)) {
        day.add(1, "w");
      }

      // Heure selectionné
      const hour = moment(day.format("DD/MM/YYYY") + ' ' + this.productsSlotForm.get("hour").value, 'DD/MM/YYYY HH:mm');

      // Objet à retourner
      const result = { day: day, hour: hour }

      this.loader = true;





      // Vérifie si le créneau séléctionné est valide
      this.orderApi.checkLimitSlot().then(data => {




        this.loader = false;

        if(data.code==-201){
          this.openAlertProductValidty(data);

        }

        // Si erreur code -75 alors on affiche la popup appropriée sinon on ferme la popup en renvoyant l'object result
        data.code === -75 ? this.openAlertPricePeriodDial(data, result) : this.dialogRef.close(result);

      });

    }

    // Sinon on ferme la popup directement
    else {
      this.dialogRef.close();
    }

  }




  openAlertPricePeriodDial(errPeriod: any, result: any) {

    const myConf = new MatDialogConfig();
    myConf.data = { errPeriod: errPeriod }
    this.media.isActive("xs") ? myConf.width = "100%" : myConf.width = "500px";
    const myDial = this.dialog.open(AlertInvalidPricePeriodComponent, myConf);
    myDial.afterClosed().subscribe(data => {

      if (data) {
        this.dialogRef.close(result);
      }

    })
  }

  /**
   * @description Effectue des actions quand la fenetre change de taille
   * @return {void}
   */
  onWindowResize() {
    this.eventHeight.subscribe(event => {
      this.innerHeight = event.target.innerHeight;
    });
  }


  openAlertProductValidty(errProductValidity: any) {

    const myConf = new MatDialogConfig();
    myConf.data = { errProductValidity: errProductValidity }
    this.media.isActive("xs")
    ? (myConf.width = "100%", myConf.height = "100%")
    : (myConf.width = "550px", myConf.minHeight = "500px");
    const myDial = this.dialog.open(AlertExpireDateProductDialogComponent, myConf);
    myDial.afterClosed().subscribe(data => {

      if (data) {
        this.dialogRef.close();
      }

    })
  }

}
